import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { theme } from '@notino/react-styleguide';
import { RoutineByProductIdQuery } from '@notino/shared/definitions/types';

import RoutineContent from '@components/Universals/Routine/RoutineContent';
import {
  Container,
  MarginWrapper,
  RoutineWrapper,
  Placeholder,
} from '@components/Universals/Routine/styled';
import { useProductSectionsStateInfo } from '@containers/ProductDetailContainer/useProductSectionsStateInfo';

export const MAX_MEDIUM_BREAKPOINT = `(max-width:${theme.breakpoints.md}rem)`;

export interface IRoutineProps {
  routine: NonNullable<
    NonNullable<
      RoutineByProductIdQuery['RoutineByProductId']['routines']
    >[number]
  >;
}
const Routine: React.FC<IRoutineProps> = ({ routine }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const { setRoutineDisplayed } = useProductSectionsStateInfo(
    (state) => state.actions
  );

  React.useEffect(() => {
    if (inView) {
      setRoutineDisplayed(true);
    }
  }, [inView, setRoutineDisplayed]);

  return (
    <Container data-testid="routine-container">
      <MarginWrapper>
        <div ref={ref}>
          {inView ? (
            <RoutineWrapper>
              <RoutineContent routine={routine} />
            </RoutineWrapper>
          ) : (
            <Placeholder />
          )}
        </div>
      </MarginWrapper>
    </Container>
  );
};

export default Routine;
